import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class InvoiceButtonModel extends ButtonBase {
    label: string = 'Invoice';
    action: string = ACTION_STATUS.invoice;
    matIconName: string = 'description';
    colorClass: string = 'color-info-500';
}